import { createAsyncThunk } from '@reduxjs/toolkit';

import { ThunkConfig } from 'app/providers/StoreProvider';
import { CatalogItem } from 'entities/CatalogItem/model/types/CatalogItemSchema';
import { ExtendedAxiosRequestConfig } from 'shared/api/types';

export const fetchInventoryItems = createAsyncThunk<
    CatalogItem[],
    string,
    ThunkConfig<string>
>('catalogItem/fetchInventoryItems', async (catalogId, thunkApi) => {
    const { extra, rejectWithValue } = thunkApi;

    try {
        const config: ExtendedAxiosRequestConfig = {
            params: {
                isInventory: true,
                is_loading_proposals: false,
            },
            keysToNotConvert: ['specifications'],
        };

        const response = await extra.api.get<CatalogItem[]>(
            `/v1/catalogs/${catalogId}`,
            config,
        );

        return response.data;
    } catch (e) {
        return rejectWithValue('error');
    }
});
